var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Your are being logged out. Please wait ...")]),_c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"blue","indeterminate":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }